@if (selectedIcon(); as icon) {
  <app-fa-icon [config]="icon" />
}
